export const CLIENT_PROFILE_COOKIE_NAME = 'gmi.profile.client';
export const CLIENT_PROFILE_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export type ClientProfileType = 'User' | 'Email';

export interface ClientProfile {
  userId: string;
  profileType: ClientProfileType;
}

const GUID_PATTERN = /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i;

export function serializeClientProfile(profile: ClientProfile): string {
  return JSON.stringify(profile);
}

export function parseClientProfile(value: string | null | undefined): ClientProfile | null {
  if (!value) {
    return null;
  }

  try {
    const profile: unknown = JSON.parse(decodeURIComponent(value));
    if (!profile || typeof profile !== 'object' || Array.isArray(profile)) {
      return null;
    }

    const { userId, profileType } = profile as Record<string, unknown>;
    if (
      typeof userId !== 'string' ||
      !GUID_PATTERN.test(userId) ||
      (profileType !== 'User' && profileType !== 'Email')
    ) {
      return null;
    }

    return { userId, profileType };
  } catch {
    return null;
  }
}

export function buildClientProfileCookie(profile: ClientProfile, persistent = false): string {
  const maxAge = persistent ? `; Max-Age=${CLIENT_PROFILE_COOKIE_MAX_AGE_SECONDS}` : '';

  return `${CLIENT_PROFILE_COOKIE_NAME}=${encodeURIComponent(
    serializeClientProfile(profile)
  )}; Path=/; Secure; SameSite=Lax${maxAge}`;
}

export function buildExpiredClientProfileCookie(): string {
  return `${CLIENT_PROFILE_COOKIE_NAME}=; Path=/; Secure; SameSite=Lax; Max-Age=0`;
}
